import React from 'react';
import styles from './InfoBox.module.scss';
const InfoBox = (props) => {
    return (
        <div className={styles.infobox}>
            <div className={styles['icon-container']}>
                {props.children}
            </div>
            <div className={styles['text-container']}>
                <p className={styles.title}>{props.title}</p>
                {props.link ? <a className={styles.text}href="mailto:bergjr.andrade@gmail.com">{props.text}</a> : <p className={styles.text}>{props.text}</p>}
            </div>
        </div>
    );
}

export default InfoBox;
